import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import type { AsyncOptionGroup } from '@/features/funnel/async-options/types';
import { Chip } from './Chip';
type SelectedChipsProps = {
  selected: AsyncOptionGroup['options'];
  onRemove: (value: string) => void;
  variant: 'circle' | 'square';
};
export function SelectedChips(t0) {
  const $ = _c(15);
  const {
    selected,
    onRemove,
    variant
  } = t0;
  if (selected.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      position: "relative",
      width: "[100%]",
      flexShrink: "[0]",
      pt: "3.5",
      pb: "2"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "relative",
      zIndex: "[1]",
      display: "flex",
      gap: "2",
      px: "3",
      maxWidth: "[640px]",
      overflowX: "auto",
      mx: "auto"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onRemove || $[3] !== selected || $[4] !== variant) {
    let t4;
    if ($[6] !== onRemove || $[7] !== variant) {
      t4 = item => <Chip key={item.value} item={item} onRemove={onRemove} variant={variant} />;
      $[6] = onRemove;
      $[7] = variant;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = selected.map(t4);
    $[2] = onRemove;
    $[3] = selected;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div aria-live="polite" aria-atomic="false" className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <section className={t1} aria-label="Selected items">{t4}</section>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}